import React from 'react'
import { Select } from 'antd'
import './filter-account.scss'


const { Option } = Select

export default ({ selectedAccount, cloudAccounts, handleCloudAccountChange, on_cloud_account_change }) => (
    <div className="analytics-filter-account round-corner">
          <Select
            value = {selectedAccount ? selectedAccount.id : null} dropdownMatchSelectWidth={false}
            onSelect={on_cloud_account_change}>
            {cloudAccounts.map((cloudAccount, index) =>
              <Option key={cloudAccount.id} value={cloudAccount.id}>
                {cloudAccount.project_name}
              </Option>
            )}
          </Select>
  </div>
)


